import { render, staticRenderFns } from "./NotificationLCR.vue?vue&type=template&id=4a444026"
import script from "./NotificationLCR.vue?vue&type=script&lang=js"
export * from "./NotificationLCR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports